/**
 * A date for a table cell, in the kit's vocabulary: "now" within the last minute, the time
 * of day for today, "Sep 6" within the year, "Aug 2025" before it. Short enough for the
 * narrowest date track; the panes keep the spoken form from `formatRelativeTime`.
 * Unparseable input is returned unchanged rather than rendered as a bogus date.
 */
export function formatShortDate(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return iso;
  if (Math.abs(now.getTime() - then.getTime()) < 60_000) return "now";
  const sameDay = then.getFullYear() === now.getFullYear() && then.getMonth() === now.getMonth() && then.getDate() === now.getDate();
  if (sameDay) return then.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  if (then.getFullYear() === now.getFullYear()) return then.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return then.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}
